import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    ViewChild,
    SimpleChanges
} from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { TooltipPosition } from '@angular/material/tooltip';

import { WorkflowState } from '../../../shared/models/workflow-state.model';
import { WorkflowTransition } from '../../../shared/models/workflow-transition.model';
import { WorkflowViewingMode } from '../../../shared/enums/workflow-viewing-mode.enum';
import { WorkflowPermissionBase } from '../../../shared/models/workflow-permission-base.model'; 
import { MatMenuTrigger } from '@angular/material/menu';
//import { MatMenuTrigger } from '@angular/material/menu/menu-trigger';

export enum WorkflowTransitionDirectionEnum {
    FORWARDS = 'forwards',
    BACKWARDS = 'backwards'
}

/*
export enum WorkflowTransitionViewModeEnum {
    PERMISSIONS = 'permissions',
    BUILD = 'build'
}
*/

// Define a type-safe hash of WorkflowState instances by Id.
interface IWorkflowStateIdToWorkflowState {
    [workflowStateId: number]: WorkflowState;
}

// Define some constants used in this class.
const FORWARD_TRANSITION_START_STATE_DIV_CSS_CLASS: string = 'forward-transition-start-state-div';
const FORWARD_TRANSITION_END_STATE_DIV_CSS_CLASS: string = 'forward-transition-end-state-div';
const FORWARD_TRANSITION_INTERMEDIATE_STATE_DIV_CSS_CLASS: string = 'forward-transition-intermediate-state-div';
const FORWARD_TRANSITION_NA_STATE_DIV_CSS_CLASS: string = 'transition-not-applicable-state-div';
const BACKWARD_TRANSITION_START_STATE_DIV_CSS_CLASS: string = 'backward-transition-start-state-div';
const BACKWARD_TRANSITION_END_STATE_DIV_CSS_CLASS: string = 'backward-transition-end-state-div';
const BACKWARD_TRANSITION_INTERMEDIATE_STATE_DIV_CSS_CLASS: string = 'backward-transition-intermediate-state-div'; //FORWARD_TRANSITION_INTERMEDIATE_STATE_DIV_CSS_CLASS;
const BACKWARD_TRANSITION_NA_STATE_DIV_CSS_CLASS: string = FORWARD_TRANSITION_NA_STATE_DIV_CSS_CLASS;

const FORWARD_TRANSITION_INVISIBLE_CONNECTOR_CSS_CLASS: string = 'invisible-forward-transition-div';
const FORWARD_TRANSITION_VISIBLE_CONNECTOR_CSS_CLASS: string = 'visible-forward-transition-div';
const BACKWARD_TRANSITION_INVISIBLE_CONNECTOR_CSS_CLASS: string = FORWARD_TRANSITION_INVISIBLE_CONNECTOR_CSS_CLASS;
const BACKWARD_TRANSITION_VISIBLE_CONNECTOR_CSS_CLASS: string = 'visible-backward-transition-div'; //FORWARD_TRANSITION_VISIBLE_CONNECTOR_CSS_CLASS;

@Component({
    selector: 'app-workflow-transition',
    templateUrl: './workflow-transition.component.html',
    styleUrls: ['./workflow-transition.component.scss'],
    standalone: false
})
export class WorkflowTransitionComponent implements OnInit {
    // Properties.
    // Inputs.
    @Input() direction: string = WorkflowTransitionDirectionEnum.FORWARDS;
    @Input() workflowTransition: WorkflowTransition;
    @Input() workflowStates: string[];
    @Input() viewMode: string = WorkflowViewingMode.PermissionsMode; //WorkflowTransitionViewModeEnum.PERMISSIONS;
    @Input() dropScope: string[];
    @Input() dragScope: string;
    @Input() hshWorkflowStatesByClientId: IWorkflowStateIdToWorkflowState = null;
    @Input() workflowStatesBeforeTransition: WorkflowState[];
    @Input() workflowStatesAfterTransition: WorkflowState[];

    @Input() permissionsPreviewDelayMs: number = 0;
    @Input() showPermissionsPreview: boolean = false;

    // Outputs.
    @Output() transitionClick: EventEmitter<any> = new EventEmitter();
    //@Output() transitionClick: EventEmitter<any> = new EventEmitter();
    @Output() dragDropAction: EventEmitter<any> = new EventEmitter();
    @Output() permissionsSummaryOpened: EventEmitter<any> = new EventEmitter();
    @Output() permissionsSummaryClosed: EventEmitter<any> = new EventEmitter();

    private bViewInitialized: boolean = false;

    @ViewChild(NgbPopover, { read: NgbPopover }) permissionsPopover: NgbPopover;
    private bPopoversTriggered: boolean = false;

    // Other properties.

    // Constructor.
    public constructor()
    {
        return;
    }

    // Life cycle methods.
    public ngOnInit(): void {
        return;
    }

    public ngAfterViewInit(): void {
        this.bViewInitialized = true;

        return;
    }

    public ngOnChanges(changes: SimpleChanges): void {
        /*
        let keys: string[] = Object.keys(changes);
        for (let iKey: number = 0; iKey < keys.length; iKey++) {
            let key: string = keys[iKey];

            let message: string = `ngOnChanges():  '${key}' ...`;
            console.log(message);

        }
        */

        /*
        if (changes['showPermissionsPreview'] != null) {
            if (this.permissionsPopover != null) {
                if (this.showPermissionsPreview) {
                    this.permissionsPopover.open();

                    this.permissionsSummaryOpened.emit();
                } else if (this.permissionsPopover.isOpen()) {
                    this.permissionsPopover.close();
                }
            }
        }
        */
        if (this.bViewInitialized && (changes['showPermissionsPreview'] != null)) {
            if (!this.bPopoversTriggered) {
                this.bPopoversTriggered = true;

                setTimeout(() => {
                    this.delayedTriggerPopovers();
                }, this.permissionsPreviewDelayMs);                
            }
        }

        return;
    }

    private delayedTriggerPopovers(): void {
        if (this.permissionsPopover != null) {
            if (this.showPermissionsPreview) {
                this.permissionsPopover.open();

                this.permissionsSummaryOpened.emit();
            } else if (this.permissionsPopover.isOpen()) {
                this.permissionsPopover.close();
            }
        }

        this.bPopoversTriggered = false;

        return;
    }

    // Accessor methods called by my HTML code.
    public get TransitionDirection(): string {
        return (this.direction);
    }

    public get Forwards(): string {
        return (WorkflowTransitionDirectionEnum.FORWARDS);
    }

    public get Backwards(): string {
        return (WorkflowTransitionDirectionEnum.BACKWARDS);
    }

    public get WorkflowTransition(): WorkflowTransition {
        return (this.workflowTransition);
    }
    public get WorkflowStates(): string[] {
        return (this.workflowStates);
    }

    public get WorkflowStateCount(): number {
        return (this.workflowStates.length);
    }

    public get ViewingMode(): string {
        return (this.viewMode);
    }
    public get ViewingModeBuilderMode(): string {
        return (WorkflowViewingMode.BuilderMode);
    }
    public get ViewingModePermissionsMode(): string {
        return (WorkflowViewingMode.PermissionsMode);
    }
    /*
    public get ViewingModeSummaryMode(): string {
        return (WorkflowViewingMode.SummaryMode);
    }
    */

    // Accessor methods related to tooltips.
    public get TooltipPosition(): TooltipPosition {
        let position: TooltipPosition = 'below';

        return (position);
    }
    public get TransitionConnectorTooltip(): string {
        let tooltip: string =
            (this.viewMode == WorkflowViewingMode.BuilderMode ?
                `Click to set the name property.  Click and hold text '${this.workflowTransition.name}' to drag this transition to the trash.` :
                'Click to set permission properties');

        return tooltip;
    }

    // Accessor methods related to drag and drop.
    public get DropScope(): string[] {
        return (this.dropScope);
    }
    public get DragScope(): string {
        return (this.dragScope);
    }

    //VNEXT-348: KLW - Transition context menu
    public workflowTransitionMenuPosition = { x: '0px', y: '0px' };
    @ViewChild('workflowTransitionMenuTrigger', { read: MatMenuTrigger }) workflowTransitionMenuTrigger: MatMenuTrigger;

    private workflowTransitionToDelete: WorkflowTransition = null;


    public displayWorkflowTransitionContextMenu(event: any, workflowTransition: WorkflowTransition): void {
        this.workflowTransitionMenuPosition.x = event.clientX + 'px';
        this.workflowTransitionMenuPosition.y = event.clientY + 'px';

        this.workflowTransitionToDelete = workflowTransition;

        this.workflowTransitionMenuTrigger.menuData = { tbd: null };
        this.workflowTransitionMenuTrigger.openMenu();
    }
    public get WorkflowTransitionMenuPositionX(): string {
        return (this.workflowTransitionMenuPosition.x);
    }
    public get WorkflowTransitionMenuPositionY(): string {
        return (this.workflowTransitionMenuPosition.y);
    }



    public BackwardTransitionWorkflowStateDivClass(workflowTransition: WorkflowTransition, workflowState: WorkflowState): string {
        let cssClass: string = '';

        let startState: WorkflowState = this.getTransitionStartState(workflowTransition);
        let endState: WorkflowState = this.getTransitionEndState(workflowTransition);

        if (workflowTransition.transientStartStateClientId === workflowState.clientId) {
            cssClass = BACKWARD_TRANSITION_START_STATE_DIV_CSS_CLASS;
        } else if (workflowTransition.transientEndStateClientId === workflowState.clientId) {
            cssClass = BACKWARD_TRANSITION_END_STATE_DIV_CSS_CLASS;
        } else if ((workflowState.stateOrder < startState.stateOrder) &&
            (workflowState.stateOrder > endState.stateOrder)) {
            cssClass = BACKWARD_TRANSITION_INTERMEDIATE_STATE_DIV_CSS_CLASS;
        } else {
            cssClass = BACKWARD_TRANSITION_NA_STATE_DIV_CSS_CLASS;
        }

        return (cssClass);
    }

    public BackwardTransitionConnectionDivClass(workflowTransition: WorkflowTransition, workflowState: WorkflowState): string {
        let cssClass: string = BACKWARD_TRANSITION_INVISIBLE_CONNECTOR_CSS_CLASS;

        let startState: WorkflowState = this.getTransitionStartState(workflowTransition);
        let endState: WorkflowState = this.getTransitionEndState(workflowTransition);

        if (workflowState.clientId == workflowTransition.transientStartStateClientId) {
            cssClass = BACKWARD_TRANSITION_VISIBLE_CONNECTOR_CSS_CLASS;
        } else if ((workflowState.stateOrder < startState.stateOrder) &&
            (workflowState.stateOrder > endState.stateOrder)) {
            cssClass = BACKWARD_TRANSITION_VISIBLE_CONNECTOR_CSS_CLASS;
        }

        return (cssClass);
    }

    public ForwardTransitionWorkflowStateDivClass(workflowTransition: WorkflowTransition, workflowState: WorkflowState): string {
        let cssClass: string = '';

        let startState: WorkflowState = this.getTransitionStartState(workflowTransition);
        let endState: WorkflowState = this.getTransitionEndState(workflowTransition);

        if (workflowTransition.transientStartStateClientId === workflowState.clientId) {
            cssClass = FORWARD_TRANSITION_START_STATE_DIV_CSS_CLASS;
        } else if (workflowTransition.transientEndStateClientId === workflowState.clientId) {
            cssClass = FORWARD_TRANSITION_END_STATE_DIV_CSS_CLASS;
        } else if ((workflowState.stateOrder > startState.stateOrder) &&
            (workflowState.stateOrder < endState.stateOrder)) {
            cssClass = FORWARD_TRANSITION_INTERMEDIATE_STATE_DIV_CSS_CLASS;
        } else {
            cssClass = FORWARD_TRANSITION_NA_STATE_DIV_CSS_CLASS;
        }

        return (cssClass);
    }

    public ForwardTransitionConnectionDivClass(workflowTransition: WorkflowTransition, workflowState: WorkflowState): string {
        let cssClass: string = FORWARD_TRANSITION_INVISIBLE_CONNECTOR_CSS_CLASS;

        let startState: WorkflowState = this.getTransitionStartState(workflowTransition);
        let endState: WorkflowState = this.getTransitionEndState(workflowTransition);

        if (workflowState.clientId == workflowTransition.transientStartStateClientId) {
            cssClass = FORWARD_TRANSITION_VISIBLE_CONNECTOR_CSS_CLASS;
        } else if ((workflowState.stateOrder > startState.stateOrder) &&
            (workflowState.stateOrder < endState.stateOrder)) {
            cssClass = FORWARD_TRANSITION_VISIBLE_CONNECTOR_CSS_CLASS;
        }

        return (cssClass);
    }

    public get WorkflowStatesBeforeTransition(): WorkflowState[] {
        return (this.workflowStatesBeforeTransition);
    }
    public get WorkflowStatesAfterTransition(): WorkflowState[] {
        return (this.workflowStatesAfterTransition);
    }

    public get WorkflowTransitionPermissionsPopoverTitle(): string {
        let title: string = null;

        let iPermissionCount: number = this.workflowTransition.PermissionCount;
        if (iPermissionCount == 0) {
            title = `${this.workflowTransition.name} Permissions`;
        } else {
            title = `${this.workflowTransition.name} Permissions (${iPermissionCount})`;
        }

        return (title);
    }

    public get PermissionCount(): number {   
        return (this.workflowTransition.PermissionCount);
    }

    public GetPermissionNames(permissionData: WorkflowPermissionBase): string {
        let names: string = '';

        /*
        let permissionNames: string[] = this.workflowTransition.getPermissionFlagNames();
        for (let iName: number = 0; iName < permissionNames.length; iName++) {
            let permissionName: string = permissionNames[iName];

            let propertyName: string = `can${permissionName}`;
            let bPermissionValue: boolean = permissionData[propertyName];

            if (bPermissionValue == true) {
                if (names != '') {
                    names += ', ';
                }

                names += permissionName;
            }
        }
        */
        if (permissionData.canEdit) {
            names = 'Transition';
        }

        return (names);
    }

    // Define methods for generating outputs.
    public outputWorkflowTransitionStateClicked(
        workflowTransition: WorkflowTransition,
        workflowState: WorkflowState,
        bIsVerticalStateConnector = false): void {
        let hshEventData = {
            'workflowTransition': workflowTransition,
            'workflowState': workflowState,
            'isVerticalStateConnector': bIsVerticalStateConnector
        }

        //this.stateClick.emit(hshEventData);
        this.transitionClick.emit(hshEventData);

        return;
    }

    public permissionsPopoverHidden(): void {
        this.permissionsSummaryClosed.emit();
    }

    public outputRoleDroppedOnWorkflowTransition(eventData: any, workflowTransition: WorkflowTransition): void {
        let hshEventData = {
            'action': 'drop',
            'event': eventData,
            'workflowTransition': workflowTransition
        }

        this.dragDropAction.emit(hshEventData);

        return;
    }

    public outputExistingWorkflowTransitionDragStart(eventData: any, workflowTransition: WorkflowTransition): void {
        let hshEventData = {
            'action': 'dragStart',
            'event': eventData,
            'workflowTransition': workflowTransition
        }

        this.dragDropAction.emit(hshEventData);

        return;
    }

    public outputExistingWorkflowTransitionDragEnd(eventData: any): void {
        let hshEventData = {
            'action': 'dragEnd',
            'event': eventData,
            'workflowTransition': null
        }

        this.dragDropAction.emit(hshEventData);

        return;
    }

    // Implement private helper methods.
    private initialize(): void {
        // Index workflow states by Id.
        //this.hshWorkflowStatesById = {};
        //this.hshWorkflowStatesByClientId = {};

        //if (this.workflowStates && (this.workflowStates.length > 0)) {
        //}
    }

    private getTransitionStartState(transition: WorkflowTransition): WorkflowState {
        //let startState: WorkflowState = this.hshWorkflowStatesByClientId[transition.startStateClientId];
        let startState: WorkflowState =
            this.hshWorkflowStatesByClientId[transition.transientStartStateClientId];

        if (!startState) {
            this.throwError('getTransitionStartState():  cannot find a workflow state by client Id.');
        }

        return (startState);
    }

    private getTransitionEndState(transition: WorkflowTransition): WorkflowState {
        //let endState: WorkflowState = this.hshWorkflowStatesByClientId[transition.endStateClientId];
        let endState: WorkflowState = this.hshWorkflowStatesByClientId[transition.transientEndStateClientId];

        if (!endState) {
            this.throwError('getTransitionEndState():  cannot find a workflow state by client Id.');
        }

        return (endState);
    }

    // Error handling.
    // Note:  should the following methods call a
    // centralized app error handling/reporting method?
    private throwError(errorMsg: string): void {
        throw (errorMsg);
    }


}
